var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-index" }, [
    _c("h3", { staticClass: "container content-title" }, [
      _vm._v("易安捷智慧电商系统 提供互联网解决方案")
    ]),
    _c("h5", { staticClass: "container lines" }),
    _c("h5", { staticClass: "container tips" }, [
      _vm._v(
        "易安捷SAAS系统, 中大型零售电商门店企业必备，一套系统管理全渠道业务。高效支撑线上线下全渠道业务，多平台数据共享模式，业务财务一体化管理，满足大中型企业定制化需求。"
      )
    ]),
    _c(
      "div",
      { staticClass: "container content-body" },
      _vm._l(_vm.content, function(item, ix) {
        return _c("div", { key: ix, staticClass: "content-body-list" }, [
          _c(
            "div",
            { staticClass: "content-body-box" },
            [
              _c("h3", [_vm._v(_vm._s(item.title))]),
              _vm._l(item.text, function(text, key) {
                return _c("p", { key: key }, [_vm._v(_vm._s(text))])
              })
            ],
            2
          ),
          _c("div", {
            staticClass: "images",
            style:
              "background: url(" +
              item.image.image +
              ") no-repeat center;background-size: cover;"
          })
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bfa5e1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bfa5e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/index/Content.vue
// module id = hWDM
// module chunks = 2